import React, { Component } from 'react';
import { DataGrid, Column, Toolbar, Item } from 'devextreme-react/data-grid';
import { hideLicenseTags, observeLicenseTags } from '../../utils/Utils.jsx'; // Import the utility function
import { Button, Checkbox } from 'semantic-ui-react';
import 'devextreme/dist/css/dx.light.css';
import RightSideFormLayout from '../../util_components/RightSideFormLayout.js';
import withSessionCheck from '../../higher_order_components/CheckSession.js';
import { Chatbot } from '../../lib/ChatbotLib.js';
import AddChatbot from './AddChatbot.js';
import { API_HOST } from '../../utils/Constants.jsx';

class ChatbotList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chatbots: [],
      error: null,
      showChatbotForm: false
    };
  }

  componentDidMount() {
    hideLicenseTags();
    // observeLicenseTags();
    if (!localStorage.getItem('apartix_session_id')) {
      window.location.href = `${window.location.origin}/login`
    } else {
      this.fetchChatbots();
    }
  }

  componentDidUpdate() {
    hideLicenseTags();
    // observeLicenseTags();
  }

  fetchChatbots = async () => {
    try {
      const response = await fetch(`https://${API_HOST}/telegram_chat_service/chat_bots`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('apartix_session_id')}` // Replace with your actual token or header value
        }
      }); // Replace with your API endpoint
      const result = await response.json();
      if (response.ok) {
        const data = result["data"].map((chatBotRecord) => {
          return new Chatbot(chatBotRecord)
        })
        this.setState({ chatbots: data });
      } else {
        this.setState({ error: result });
      }
    } catch (err) {
      this.setState({ error: err.message });
    }
  };

  handleAddChatbot = () => {
    // Logic to add a new chatbot
    this.setState({
      showChatbotForm: true,
      selectedChatbot: new Chatbot({id: null, name: null, api_token: null, is_active: false, bot_username: null, chat_bot_type: "Society"})
    })
  };

  handleDeleteChatbot = (id) => {
    // Logic to delete a chatbot by id
    const toDeleteChatbot = this.state.chatbots.filter(chatbot => chatbot.id() !== id)[0];
    if (toDeleteChatbot.deleteRecord()) {
    }

  };

  handleActivateChatbot = (id) => {
    const toEditChatbot = this.state.chatbots.filter(chatbot => chatbot.id() !== id)[0];
    toEditChatbot.editRecord();
  }

  closeAddChatbotSidebar = () => {
    this.setState({
      showChatbotForm: false,
      selectedChatbot: null
    })
  }

  updateChatBotList = (chatBot) => {
    const { chatbots } = this.state;
    this.setState({
      chatbots: [...chatbots, chatBot]
    })
    if (chatBot) {
    }
  }

  render() {
    hideLicenseTags();
    const { chatbots, showChatbotForm, selectedChatbot, error } = this.state;

    return (
      <div className='chatbot-list-container'>
        {error && <p>Error: {error}</p>}
        {showChatbotForm && (
          <RightSideFormLayout onClose={this.closeAddChatbotSidebar}>
            <AddChatbot chatbot={selectedChatbot} handleSidebarClose={this.closeAddChatbotSidebar} updateChatBotList={this.updateChatBotList} />
          </RightSideFormLayout>
        )}
        <DataGrid
          dataSource={chatbots}
          keyExpr="id"
          showBorders={true}
        >
          <Column dataField="name" caption="Name" />
          <Column dataField="is_active" caption="Status" cellRender={({data}) => {
            const isActive = data.isActive();
            return <Checkbox className="app-custom-toggle" toggle checked={isActive} onChange={(e, checkboxData) => {
              const chatbotId = data.id();
              const value = checkboxData.checked;
              console.log(chatbotId, value); //Replace with handler method based on the checkbox value.
            }} />
          }} />
          {/*<Column
            caption="Actions"
            cellRender={({ data }) => (
              <Button

                onClick={() => data.isActive() ? this.handleDeleteChatbot(data.id) : this.handleActivateChatbot(data.id)}
              >{data.isActive() ? "Deactivate" : "Activate"}</Button>
            )}
          />*/}
          <Toolbar>
            <Item location="after">
              <Button
                primary
                className="add-chatbot-button"
                onClick={this.handleAddChatbot}
              >{"+ Add Chatbot"}</Button>
            </Item>
          </Toolbar>
        </DataGrid>
      </div>
    );
  }
}

export default ChatbotList;
